import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Link, useParams } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import axios from "axios";

import { Footer, Navbar } from "../components";

const Product = () => {
  const { id } = useParams();
  const [product, setProduct] = useState({});
  const [similarProducts, setSimilarProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [caracteristicas, setCaracteristicas] = useState([]);
  const [categorias, setCategorias] = useState([]);

  const dispatch = useDispatch();

  const addProduct = (product) => {
    dispatch(addCart(product));
  };

  useEffect(() => {
    const getProduct = async () => {
      setLoading(true);
      setLoading2(true);
      await fetchCaracteristicas(id);
      await fetchCategorias(id);
      const response = await fetch(`https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/obtproducto/${id}`);
      const data = await response.json();
      setProduct(data.data);
      setLoading(false);
      const response2 = await fetch(
        "https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/obtproductos"
      );
      const data2 = await response2.json();
      setSimilarProducts(data2.data);
      setLoading2(false);
    };
    getProduct();
  }, [id]);

  const fetchCategorias = async (id) => {
    try {
      const response = await axios.get(
        `https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/obtcategorias/producto/${id}`
      );
      const responseData = response.data;
      setCategorias(responseData.data[0]);
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
  };

  const fetchCaracteristicas = async (id) => {
    try {
      const response = await axios.get(
        `https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/obtcaracteristicas/producto/${id}`
      );
      const responseData = response.data;
      setCaracteristicas(responseData.data[0]);
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
  };

  const Loading = () => {
    return (
      <>
        <div className="container my-5 py-2">
          <div className="row">
            <div className="col-md-6 py-3">
              <Skeleton height={400} width={400} />
            </div>
            <div className="col-md-6 py-5">
              <Skeleton height={30} width={250} />
              <Skeleton height={90} />
              <Skeleton height={40} width={70} />
              <Skeleton height={50} width={110} />
              <Skeleton height={120} />
              <Skeleton height={40} width={110} inline={true} />
              <Skeleton className="mx-3" height={40} width={110} />
            </div>
          </div>
        </div>
      </>
    );
  };

  const ShowProduct = () => {
    return (
      <>
        <div className="container my-5 py-2">
          <div className="row">
            <div className="col-md-6 col-sm-12 py-3">
              <img
                className="img-fluid"
                src={product.imagen}
                alt={product.nombre}
                width="400px"
                height="400px"
              />
            </div>
            <div className="col-md-6 col-md-6 py-5">
              <h1 className="display-5">{product.nombre}</h1>
              <h3 className="display-6  my-4">${product.precio}</h3>
              <p className="lead">{product.descripcion}</p>
              <h1 className="text-center">Caracteristicas</h1>
            <ul className="card container-fluid">
              {caracteristicas.map((elemento) => (
                <li className="card my-2" key={elemento.id}>
                  <h3>{elemento.nombre}</h3>
                  <p>{elemento.valor}</p>
                </li>
              ))}
            </ul>
            <h1 className="text-center">Categorias</h1>
            <ul className="card container-fluid">
              {categorias.map((elemento) => (
                <li className="card my-2" key={elemento.id}>
                  <h3>{elemento.nombre}</h3>
                  <p>{elemento.descripcion}</p>
                </li>
              ))}
            </ul>
              <button
                className="btn btn-outline-dark"
                onClick={() => addProduct(product)}
              >
                Agregar al carrito
              </button>
              <Link to="/cart" className="btn btn-dark mx-3">
                Ir al carrito
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  };

  const Loading2 = () => {
    return (
      <>
        <div className="my-4 py-4">
          <div className="d-flex">
            <div className="mx-4">
              <Skeleton height={400} width={250} />
            </div>
            <div className="mx-4">
              <Skeleton height={400} width={250} />
            </div>
            <div className="mx-4">
              <Skeleton height={400} width={250} />
            </div>
            <div className="mx-4">
              <Skeleton height={400} width={250} />
            </div>
          </div>
        </div>
      </>
    );
  };

  const ShowSimilarProduct = () => {
    return (
      <>
        <div className="py-4 my-4">
          <div className="d-flex">
            {similarProducts.map((item) => {
              return (
                <div key={item.id} className="card mx-4 text-center">
                  <img
                    className="card-img-top p-3"
                    src={item.imagen}
                    alt="Card"
                    height={300}
                    width={300}
                  />
                  <div className="card-body">
                    <h5 className="card-title">
                      {item.nombre.substring(0, 15)}...
                    </h5>
                  </div>
                  <div className="card-body">
                    <Link
                      to={"/product/" + item.id}
                      className="btn btn-dark m-1"
                    >
                      Comprar ahora
                    </Link>
                    <button
                      className="btn btn-dark m-1"
                      onClick={() => addProduct(item)}
                    >
                      Agregar al carrito
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Navbar />
      <div className="container">
        <div className="row">{loading ? <Loading /> : <ShowProduct />}</div>
        <div className="row my-5 py-5">
          <div className="d-none d-md-block">
            <h2 className="">También te puede gustar</h2>
            <Marquee pauseOnHover={true} pauseOnClick={true} speed={50}>
              {loading2 ? <Loading2 /> : <ShowSimilarProduct />}
            </Marquee>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Product;
